import { locationIds } from "../core/enums";
import { Location } from "../graphql/operations";

export const getCityUrl = (location: Pick<Location, "id" | "slug">) => {
  if (location.id === locationIds.TOKYO || location.id === locationIds.KYOTO) {
    return location.id;
  }
  return location.slug;
};
